import axios from 'axios'

const {
  VUE_APP_URL, VUE_APP_AMEX
} = process.env

const fetchAddressInfo = (postcode, ref) => {
  return axios
    .get(`${VUE_APP_URL}${ref}/api/address/${postcode}`)
    .then((res) => {
      return res.data.results
    })
}

const getFullAddressInfo = (url) => {
  return axios
    .get(url)
    .then((res) => {
      return res.data.address
    })
}

const amexButtonPayment = async (booking, ref) => {
  let url
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
    url = 'https://test.trailfinders.com/giftcards#'
  } else {
    url = `https://www.trailfinders${ref}/giftcards#`
  }
  try {
    window.$pwb.openWindow()
    console.log(booking)
    // send payment confirmation before payments
    // orderId added serverside
    const res = await axios
      .post(`${VUE_APP_AMEX}/button`, {
        tfSystem: 'giftcard',
        customerId: booking.customerId,
        redirect: `${url}/amex/${booking.customerId}`,
        amount: booking.purchaseAmount,
        currency: booking.currencyCode,
        address1: booking.billingAddressLine1,
        address2: booking.billingAddressLine2,
        address3: booking.billingAddressLine3,
        postcode: booking.billingAddressPostcode,
        email: booking.email,
        phone: booking.phone,
        name: booking.name,
        title: booking.title,
        firstname: booking.firstname,
        surname: booking.surname,
        logname: booking.logname,
        staffid: booking.staffid,
        giftcardData: booking.giftcardData
      })
    if (res && res.data) {

      window.$pwb.updateInit(res.data)
      return res.data
    }
  } catch (err) {
    window.$pwb.updateInit(false)
    console.log(err)
    return null
  }
}

const amexUpdate = async (payload) => {
  const result = { error: false }
  try {
    const url = `${VUE_APP_AMEX}/gccallback`

    const res = await axios.post(url, payload)
    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

export {
  fetchAddressInfo,
  getFullAddressInfo,
  amexButtonPayment,
  amexUpdate
}
